<section id="save-template-section" data-testid="save-template-section">
  <div id="subtitle-and-switch">
    <h2 id="subtitle">Save this as a template</h2>
    <as-switch id="save_template_toggle" data-testid="save-template-toggle" [checkedLabel]="'ON'" [uncheckedLabel]="'OFF'"
      [checked]="!toggleOff" (change)="onChangeToggle($event)"></as-switch>
  </div>
  <span id="save-template-messaging">{{templateMessaging}}</span>
  <mm-text-input-control *ngIf="showNicknameControl" [parentForm]="optionsForm" [inputControlModel]="nicknameModel"
    [errorMessage]="nicknameErrorMessage" id="save-template-nickname" [errorMessage]="nicknameError || ''"></mm-text-input-control>
  <sdps-divider id="bottom-divider" variation="secondary"></sdps-divider>
</section>